const Settings = (props) => {
    return(
        <>
            settings
        </>
    )
}

export default Settings